import {
  contentServiceGet,
  profileServiceDelete,
  tvaultServiceGet,
  mvaultService,
  activateTemporarySetting,
  TEMPORAL_SETTINGS_AVAILABLE,
} from '../lib/utils.js'
import { store } from '../store'
import configuration from '../configuration.js'
import {
  platformStoreDelete,
  platformStoreGet,
  platformStoreSet,
  triggerSentryError,
} from '../../../shared/helpers.js'
import PBSError from '../../../shared/PBSError'
import { acceptVppa } from './contentActions.js'
import Platform from '../platforms'

export function registerUser(uid) {
  let user = {
    pid: uid,
    memberships: [],
    validPassportForCurrentStation: false,
    validPassport: false,
    first_name: 'Unknown',
    last_name: 'User',
    email: 'Unknown User',
    vppa_accepted: false,
    vppa_last_updated: '',
    vppa_status: 'never_accepted',
  }
  let url = configuration.apiUrls.getUserInfo
    .replace('[uid]', uid)
    .replace('[DEVICETYPE]', Platform.deviceType)

  return contentServiceGet(url)
    .then((resp) => {
      user = resp.resource

      user.memberships = []
      user.validPassportForCurrentStation = false
      user.validPassport = false

      if (user.has_memberships) {
        let url = configuration.apiUrls.getUserMembershipStations
          .replace('[UID]', uid)
          .replace('[DEVICETYPE]', Platform.deviceType)

        return contentServiceGet(url)
          .then((resp) => {
            if (resp.collections && resp.collections[0]) {
              user.memberships = resp.collections[0].content

              user.validPassport = false
              user.validPassportForCurrentStation = false

              for (let i = 0; i < user.memberships.length; i++) {
                const element = user.memberships[i]

                if (element.mvod_enabled) {
                  user.validPassport = true
                  if (
                    element.call_sign &&
                    element.call_sign === store.getState().station.call_sign
                  ) {
                    user.validPassportForCurrentStation = true
                  }
                }
              }
            }
            store.dispatch({
              type: 'UPDATE_USER_PROFILE',
              payload: user,
            })
            return Promise.resolve()
          })
          .catch((err) => {
            triggerSentryError(
              '[index] Error getting user memberships',
              'userActions.js',
              {
                url,
                errorMessage:
                  err.message ?? 'Undefined error message (default)',
                errorLocation: 'User Actions - registerUser - user memberships',
              }
            )

            //TODO: should this be a reject?
            return Promise.resolve()
          })
      } else {
        store.dispatch({
          type: 'UPDATE_USER_PROFILE',
          payload: user,
        })
        return Promise.resolve()
      }
    })
    .catch((err) => {
      triggerSentryError('[index] Error getting user info', 'userActions.js', {
        url,
        errorMessage: err.message ?? 'Undefined error message (default)',
        errorLocation: 'User Actions - registerUser - getUserInfo',
      })

      store.dispatch({
        type: 'UPDATE_USER_PROFILE',
        payload: user,
      })
      //TODO: should this be a reject?
      return Promise.resolve()
    })
}

export function signoutUser() {
  const deviceStore = store.getState().device
  const uidKey = `uID-ga`
  const url = configuration.apiUrls.deviceDeactivation
    .replace('[UID]', platformStoreGet(uidKey))
    .replace('[deviceId]', deviceStore.deviceId)

  return profileServiceDelete(url)
    .then(() => {
      platformStoreDelete(uidKey)

      if (COMPILING_FOR_COMCASTX1) {
        import('@firebolt-js/sdk').then(async function (firebolt) {
          const Discovery = firebolt.Discovery

          Discovery.signOut()
        })
      }
      return Promise.resolve()
    })
    .catch((err) => {
      triggerSentryError('[index] Error logging user out', 'userActions.js', {
        url,
        errorMessage: err.message ?? 'Undefined error message (default)',
        errorLocation: 'User Actions - signoutUser',
      })

      return Promise.reject(err)
    })
}

export async function checkPassportStatus(station) {
  const user = store.getState().user
  const url = configuration.apiUrls.checkPassportStatus
    .replace('[PID]', user.pid)
    .replace('[STATION_ID]', station)
  try {
    const {
      data: {
        attributes: {
          membership: {
            current_state: {
              explanation: { token_activated },
            },
            mvault_id,
          },
        },
      },
    } = await tvaultServiceGet(url)

    if (token_activated) {
      activateTemporarySetting(TEMPORAL_SETTINGS_AVAILABLE.PASSPORT)
      return 'ACTIVATED' // The user has activated their Passport benefit.
    } else {
      platformStoreSet('mvault_id', mvault_id)
      return 'PENDING' // The user has made a qualifying donation, but has not activated their Passport benefit.
    }
  } catch (error) {
    if (error.status === 404) {
      return 'NO_MEMBERSHIP' // No membership linked to a TVault dontion was found.
    } else {
      console.error(error)
    }
  }
}

export async function activatePassport() {
  try {
    const MVAULT_ID_KEY = 'mvault_id'
    const mvault_id = platformStoreGet(MVAULT_ID_KEY)
    const uid = store.getState().user.pid
    const data = { uid }
    await mvaultService(
      configuration.apiUrls.activatePassport.replace('[MVAULT_ID]', mvault_id),
      'PATCH',
      data
    )
    await acceptVppa(uid).then(() => {
      activateTemporarySetting(TEMPORAL_SETTINGS_AVAILABLE.VPPA)
    })

    activateTemporarySetting(TEMPORAL_SETTINGS_AVAILABLE.PASSPORT)
  } catch (e) {
    throw new PBSError(e, 'MVAULT_ERROR')
  }
}
